import React from "react"
import Section from "../../../../core/layout/main/section/Section"
import * as RhCtxAgencyMosaic from "./RhCtxAgencyMosaicSection.module.scss"
import Image from "../../../common/blocks/image/Image"
const RhCtxAgencyMosaicSection = ({ lastJobAdsImg }) => {
  // const calculateColumns = (width) => {
  //   const columnWidth = 600;
  //   const maxColumns = 3;
  //   const wideThreshold = 600;
  //   let columns = Math.ceil(width / columnWidth);
  //   // console.log("here",columns);
  //   if (width > wideThreshold) {
  //     columns = Math.min(columns, 2); // Limit to 2 columns if image is wide
  //   }

  //   console.log(columns, maxColumns);
  //   return Math.min(columns, maxColumns);
  // };

  return (
    <>
      <Section
        className="pbl-6 pin-0"
        container="xxlarge"
      >
        <div className={`${RhCtxAgencyMosaic.grid} loadin`}>
          {lastJobAdsImg?.data?.map((img, i) => (
            <div
              className={`${RhCtxAgencyMosaic.imageContainer}`}
              // style={{ gridColumnEnd: `span ${calculateColumns(img.attributes.width)}` }}
            >
              <Image
                key={i}
                dataSizesPreset="hero"
                className={RhCtxAgencyMosaic.image}
                imgSrc={img.attributes.url}
                imgAlt={img.attributes.alternativeText}
                formats={img?.attributes?.formats}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </Section>
    </>
  )
}
export const name = "RhCtxAgencyMosaic"

export const init = (componentData, pageContext) => {
  const lastJobAds = pageContext.itemData
  return (
    <RhCtxAgencyMosaicSection
      key={componentData.id}
      lastJobAdsImg={lastJobAds?.attributes?.images}
    />
  )
}

export default RhCtxAgencyMosaicSection
